import React, { useEffect , useState } from "react";
import { useDispatch } from "react-redux";

import {
	Button,
	Stack,
	useDisclosure,
	Modal,
	ModalOverlay,
	ModalHeader,
	ModalContent,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	Text,
	FormControl,
	FormLabel,
	Input,
	Box,
	useToast,
	Table,
	Thead,
	Tr,
	Th,
	Tbody,
	Td,
	Select,
	Badge,
	Grid,
	GridItem,
	Icon,
	HStack,
	useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import moment from "moment";
import { FiEdit2, FiSave, FiX, FiEye } from "react-icons/fi";


import Dropzone from "../../Components/Dropzone/Dropzone";
import Gallery from "../../Components/Gallery/Gallery";
import TenantsDocumentsTableRow from "../../Components/TableRows/TenantsDocumentsTableRow";
import { addTenantDocumentAsync, updateTenantAsync, uploadTenantIdAsync } from "../../redux/user/userSlice";
import { _arrayBufferToBase64 } from "../../utils/convertors";
import { API } from "../../utils/http";
import { fullDateFormat } from "../../utils/types";


const MotionBox = motion(Box);

export default function PersonalInformation({ tenant, propertyId }) {
	const initialIdInformation = { idData: "", contentType: "", email: tenant.email, expirationDate: "", dateOfBirth: "", propertyId };
	const initialTenantInformation = {
		name: tenant.name,
		phoneNumber: tenant.phoneNumber,
		phoneNumber2: tenant.phoneNumber2,
		email: tenant.email,
		expirationDate: tenant.identificationDocument?.expirationDate,
		dateOfBirth: tenant.identificationDocument?.dateOfBirth,
		propertyId,
	};
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { isOpen: isAddDocumentOpen, onOpen: onAddDocumentOpen, onClose: onAddDocumentClose } = useDisclosure();
	const { isOpen: isPreviewOpen, onOpen: onPreviewOpen, onClose: onPreviewClose } = useDisclosure();
	const toast = useToast();
	const [isEditing, setIsEditing] = useState(false);
	const [idInformation, setIdInformation] = useState(initialIdInformation);
	const [documentInformation, setDocumentInformation] = useState();
	const [tenantInformation, setTenantInformation] = useState(initialTenantInformation);
	const [id, setId] = useState([]);
	useEffect(() => {
		console.log(documentInformation);
	}, [documentInformation]);
	const dispatch = useDispatch();
	const uploadId = () => {
		console.log(idInformation);
		dispatch(uploadTenantIdAsync(idInformation))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Tenant Added!",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				setIdInformation(initialIdInformation);
				onClose();
			});
	};
	const addDocument = () => {
		console.log(documentInformation);
		const payload = { ...documentInformation, email: tenant.email };
		console.log(payload);
		dispatch(addTenantDocumentAsync(payload))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Document Added!",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				setDocumentInformation();
				onAddDocumentClose();
			});
	};
	useEffect(() => {
		console.log("getting tenant id");
		if (tenant.identificationDocument?.id)
			API.put("get-tenant-document-url", { tenantEmail: tenant.email, documentId: tenant.identificationDocument.id }).then((r) => {
				console.log(r.data);
				console.log(r.data.id);
				setId([{ ...tenant.identificationDocument, url: r.data.url }]);
			});
	}, [tenant]);
	const onIdDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const contentType = acceptedFiles[0].type;
		setIdInformation({ ...idInformation, idData: _arrayBufferToBase64(buffer), contentType });
	};
	const onDocumentDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const contentType = acceptedFiles[0].type;
		const documentName = acceptedFiles[0].name;
		// setIdInformation({ ...idInformation, idData: _arrayBufferToBase64(buffer), contentType });
		setDocumentInformation({ ...documentInformation, documentData: _arrayBufferToBase64(buffer), documentName, contentType });
	};
	const handleSave = () => {
		console.log(tenantInformation);
		dispatch(updateTenantAsync(tenantInformation))
			.then((r) => {
				if (r.error?.message)
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				else {
					toast({
						title: "Success!",
						description: "Tenant Updated!",
						status: "success",
						duration: 2000,
						isClosable: true,
					});
				}
			})
			.finally(() => {
				setIsEditing(false);
			});
	};
	const handleIdInformationChange = (e) => {
		setIdInformation({ ...idInformation, [e.target.name]: e.target.value });
	};
	const handleOwnerInformationChange = (e) => {
		setTenantInformation({ ...tenantInformation, [e.target.name]: e.target.value });
	};
	const renderAddDocumentModal = () => (
		<Modal isOpen={isAddDocumentOpen} onClose={onAddDocumentClose} size={"xl"}>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
			<ModalContent>
				<ModalHeader>
					<Text>Add Document</Text>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Stack>
						<FormControl display={"flex"} alignItems="center">
							<FormLabel display={"inline"}>Type:</FormLabel>
							<Select
								width={"fit-content"}
								onChange={(e) => {
									setDocumentInformation({ ...documentInformation, type: e.target.value });
								}}
								name="type"
								placeholder="Type"
								_placeholder={{ color: "gray.500" }}
							>
								<option value="certificate">Adeverinta</option>
								<option value="passport">Pasaport</option>
								<option value="other">Altele</option>
							</Select>
						</FormControl>
						<Dropzone onDrop={onDocumentDrop} accept={{ "application/*": [".pdf"], "image/*": [] }} description="Upload a Document" maxFiles={1} />
					</Stack>
				</ModalBody>
				<ModalFooter>
					<Button colorScheme="red" onClick={onAddDocumentClose} mr={3}>
						Cancel
					</Button>
					<Button colorScheme="blue" onClick={addDocument}>
						Upload
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
	const renderUploadIdModal = () => (
		<Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
			<ModalContent>
				<ModalHeader>
					<Text>Add ID</Text>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Stack>
						<FormControl>
							<FormLabel display={"inline"}>Expiration Date:</FormLabel>
							<Input width={"fit-content"} type="date" value={idInformation.expirationDate} name="expirationDate" onChange={handleIdInformationChange} />
						</FormControl>
						<FormControl>
							<FormLabel display={"inline"}>Date of Birth:</FormLabel>
							<Input width={"fit-content"} type="date" value={idInformation.dateOfBirth} name="dateOfBirth" onChange={handleIdInformationChange} />
						</FormControl>
						<FormControl>
							<FormLabel>ID:</FormLabel>
							<Dropzone onDrop={onIdDrop} accept={{ "application/*": [".pdf"], "image/*": [] }} description="Upload an Image" maxFiles={1} />
						</FormControl>
					</Stack>
				</ModalBody>
				<ModalFooter>
					<Button colorScheme="red" onClick={onClose} mr={3}>
						Cancel
					</Button>
					<Button colorScheme="blue" onClick={uploadId}>
						Upload
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
	const renderIdPreviewModal = () => (
		<Modal isOpen={isPreviewOpen} onClose={onPreviewClose} size="4xl">
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
			<ModalContent>
				<ModalHeader>ID Document</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box borderRadius="md" overflow="hidden">
						<Gallery items={id} />
					</Box>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
	const bgColor = useColorModeValue("white", "gray.800");
	const borderColor = useColorModeValue("gray.200", "gray.700");
	const labelColor = useColorModeValue("gray.600", "gray.400");
	const valueColor = useColorModeValue("gray.800", "white");
	return (
		<MotionBox initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
			<Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={8}>
				<GridItem>
					<Box p={6} bg={bgColor} borderRadius="lg" borderWidth="1px" borderColor={borderColor} boxShadow="sm" position="relative">
						<HStack justify="space-between" mb={6}>
							<Text fontSize="lg" fontWeight="bold">
								Personal Details
							</Text>
							<Button
								size="sm"
								variant="ghost"
								colorScheme={isEditing ? "red" : "blue"}
								leftIcon={<Icon as={isEditing ? FiX : FiEdit2} />}
								onClick={() => {
									if (isEditing) {
										setTenantInformation(initialTenantInformation);
									}
									setIsEditing(!isEditing);
								}}
							>
								{isEditing ? "Cancel" : "Edit"}
							</Button>
						</HStack>

						<Stack spacing={4}>
							<FormControl>
								<FormLabel color={labelColor}>Name</FormLabel>
								{isEditing ? (
									<Input size="md" value={tenantInformation.name} name="name" onChange={handleOwnerInformationChange} />
								) : (
									<Text color={valueColor}>{tenantInformation.name}</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Primary Phone</FormLabel>
								{isEditing ? (
									<Input size="md" value={tenantInformation.phoneNumber} name="phoneNumber" onChange={handleOwnerInformationChange} />
								) : (
									<Text color={valueColor}>{tenantInformation.phoneNumber}</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Secondary Phone</FormLabel>
								{isEditing ? (
									<Input size="md" value={tenantInformation.phoneNumber2} name="phoneNumber2" onChange={handleOwnerInformationChange} />
								) : (
									<Text color={valueColor}>{tenantInformation.phoneNumber2 || "-"}</Text>
								)}
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Email</FormLabel>
								<Text color={valueColor}>{tenantInformation.email}</Text>
							</FormControl>

							{isEditing && (
								<Button colorScheme="blue" leftIcon={<Icon as={FiSave} />} onClick={handleSave} mt={4}>
									Save Changes
								</Button>
							)}
						</Stack>
					</Box>
				</GridItem>

				<GridItem>
					<Box p={6} bg={bgColor} borderRadius="lg" borderWidth="1px" borderColor={borderColor} boxShadow="sm">
						<Text fontSize="lg" fontWeight="bold" mb={6}>
							Identification
						</Text>
						<Stack spacing={4}>
							<FormControl>
								<FormLabel color={labelColor}>ID Expiration Date</FormLabel>
								<HStack>
									{tenant.identificationDocument?.expirationDate ? (
										<Badge colorScheme={moment(tenant.identificationDocument.expirationDate).unix() < moment().unix() ? "red" : "green"}>
											{moment(tenant.identificationDocument.expirationDate).format(fullDateFormat)}
										</Badge>
									) : (
										<Text color={valueColor}>No ID uploaded</Text>
									)}
									<Button size="sm" colorScheme="blue" onClick={onOpen}>
										{tenant.identificationDocument?.id ? "Update ID" : "Upload ID"}
									</Button>
								</HStack>
							</FormControl>

							<FormControl>
								<FormLabel color={labelColor}>Date of Birth</FormLabel>
								<Text color={valueColor}>
									{tenant.identificationDocument ? moment(tenant.identificationDocument?.dateOfBirth).format(fullDateFormat) : "No ID uploaded"}
								</Text>
							</FormControl>

							{tenant.identificationDocument?.id && (
								<FormControl>
									<FormLabel color={labelColor}>ID Preview</FormLabel>
									<Button leftIcon={<Icon as={FiEye} />} size="sm" variant="outline" colorScheme="blue" onClick={onPreviewOpen}>
										View ID Document
									</Button>
								</FormControl>
							)}
						</Stack>
					</Box>
				</GridItem>

				<GridItem colSpan={{ base: 1, md: 2 }}>
					<Box p={6} bg={bgColor} borderRadius="lg" borderWidth="1px" borderColor={borderColor} boxShadow="sm">
						<HStack justify="space-between" mb={6}>
							<Text fontSize="lg" fontWeight="bold">
								Documents
							</Text>
							<Button size="sm" colorScheme="blue" onClick={onAddDocumentOpen}>
								Add Document
							</Button>
						</HStack>

						<Table variant="simple">
							<Thead>
								<Tr>
									<Th>Type</Th>
									<Th>Name</Th>
									<Th>Upload Date</Th>
									<Th>Actions</Th>
								</Tr>
							</Thead>
							<Tbody>
								{tenant.documents?.length > 0 ? (
									tenant.documents.map((doc) => <TenantsDocumentsTableRow key={doc.id} document={doc} tenantEmail={tenant.email} />)
								) : (
									<Tr>
										<Td colSpan={4}>
											<Box py={4} textAlign="center">
												<Text color={labelColor}>No documents uploaded yet</Text>
												<Button size="sm" colorScheme="blue" variant="link" onClick={onAddDocumentOpen} mt={2}>
													Upload your first document
												</Button>
											</Box>
										</Td>
									</Tr>
								)}
							</Tbody>
						</Table>
					</Box>
				</GridItem>
			</Grid>

			{renderAddDocumentModal()}
			{renderUploadIdModal()}
			{renderIdPreviewModal()}
		</MotionBox>
	);
}
